import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { api } from "../services";
import { isAllowedLandingSubdomain } from "../utils/helpers";
import { saveReturnUrl } from "../utils/authRedirect";

export const ProtectedRoute = ({ requireAdminAccess }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const currentUser = useSelector((state) => state.auth.currentUser);
  const token = localStorage.getItem("token");
  const isAuthenticated = !!token || !!currentUser;
  const isAdmin = localStorage.getItem("is_admin");
  const loginPath = isAdmin === "true" ? "/login/admin" : "/login";

  useEffect(() => {
    if (!isAuthenticated) {
      dispatch(api.util.resetApiState());
    }
  }, [isAuthenticated, dispatch]);

  if (!isAuthenticated) {
    if (!requireAdminAccess) {
      saveReturnUrl(location.pathname + location.search);
    }
    return <Navigate to={loginPath} />;
  }

  if (!requireAdminAccess) return <Outlet />;
  return isAdmin == "true" ? <Outlet /> : <Navigate to="/login" />;
};

export const ProtectedLogin = () => {
  const currentUser = useSelector((state) => state.auth.currentUser);
  const token = localStorage.getItem("token");
  const isAuthenticated = !!token || !!currentUser;
  const isAdmin = localStorage.getItem("is_admin");
  return isAuthenticated ? (
    isAdmin == "true" ? (
      <Navigate to="/admin" />
    ) : (
      <Navigate to="/employee" />
    )
  ) : (
    <Outlet />
  );
};

export const RouteToHome = () => {
  const currentUser = useSelector((state) => state.auth.currentUser);
  const token = localStorage.getItem("token");
  const isAuthenticated = !!token || !!currentUser;
  const isAdmin = localStorage.getItem("is_admin");
  if (!isAuthenticated) return <Outlet />;
  else if (isAdmin == "false") return <Navigate to="/employee" />;
  else return <Navigate to="/admin" />;
};

export const ProtectedLandingPage = () => {
  if (isAllowedLandingSubdomain()) {
    return <Outlet />;
  } else {
    return <Navigate to="/login" replace />;
  }
};
